/**
 * @generated SignedSource<<eb0634c4e96061bc13f73e0a749f4836>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoStoresListItemResponse_todoResponse$data = {
  readonly __typename: "TodoResponseImage";
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoStoresListItemResponseImage_todoImageResponse">;
  readonly " $fragmentType": "WorkspaceTodoStoresListItemResponse_todoResponse";
} | {
  readonly __typename: "TodoResponseNumber";
  readonly value: number | null;
  readonly " $fragmentType": "WorkspaceTodoStoresListItemResponse_todoResponse";
} | {
  readonly __typename: "TodoResponseText";
  readonly text: string | null;
  readonly " $fragmentType": "WorkspaceTodoStoresListItemResponse_todoResponse";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "WorkspaceTodoStoresListItemResponse_todoResponse";
};
export type WorkspaceTodoStoresListItemResponse_todoResponse$key = {
  readonly " $data"?: WorkspaceTodoStoresListItemResponse_todoResponse$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoStoresListItemResponse_todoResponse">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoStoresListItemResponse_todoResponse",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "type": "TodoResponseNumber",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceTodoStoresListItemResponseImage_todoImageResponse"
        },
        (v0/*: any*/)
      ],
      "type": "TodoResponseImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "type": "TodoResponseText",
      "abstractKey": null
    }
  ],
  "type": "TodoResponse",
  "abstractKey": "__isTodoResponse"
};
})();

(node as any).hash = "c15ce6dfc7be6a933c9be8c945e0e672";

export default node;
